import { useEffect } from 'react';
import PropTypes from 'prop-types';
import IntercomHelper from "../IntercomHelper/IntercomHelper";
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
const IntercomWrapper = _ref => {
  let {
    children,
    intercomId,
    session,
    source,
    companies = undefined,
    name = undefined,
    userHash = undefined,
    userId = undefined,
    userEmail = undefined
  } = _ref;
  const componentGracefulUnmount = () => {
    IntercomHelper.decrementIntercomSessions();

    // clean up our window event listener
    if (typeof window !== 'undefined') {
      window.removeEventListener('beforeunload', componentGracefulUnmount);
    }
  };
  useEffect(() => {
    // Set up the listener for the window event
    if (typeof window !== 'undefined') {
      window.addEventListener('beforeunload', componentGracefulUnmount);
    }

    // Update Intercom with the new session or possible updated intercom session
    IntercomHelper.bootUpdate({
      session,
      intercomId,
      source,
      companies,
      name,
      userId,
      intercomUserHash: userHash,
      userEmail
    });

    // Increment the intercom sessions
    IntercomHelper.incrementIntercomSessions();

    // Cleanup function for component unmount
    return () => {
      componentGracefulUnmount();
    };
  }, [session, intercomId, source, companies, name, userId, userHash, userEmail]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};
IntercomWrapper.propTypes = {
  children: PropTypes.element.isRequired,
  intercomId: PropTypes.string.isRequired,
  session: PropTypes.object.isRequired,
  source: PropTypes.string.isRequired,
  companies: PropTypes.array,
  userHash: PropTypes.string,
  name: PropTypes.string,
  userId: PropTypes.string,
  userEmail: PropTypes.string
};
export default IntercomWrapper;
//# sourceMappingURL=IntercomWrapper.js.map